// Module
var code = "<!-- ko with: CanvasDesignerControl--> <div data-bind=\"template: { name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data) }\"></div> <!-- /ko -->";
// Exports
export default code;